import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "vw-toggleable",
  templateUrl: "./toggleable.component.html",
})
export class ToggleableComponent implements OnInit {
  @Input() defaultToggled: boolean = false;
  @Input() entireHeaderClickable: boolean = false;

  toggled: boolean = false;

  constructor() {}

  ngOnInit(): void {
    this.toggled = this.defaultToggled;
  }

  toggle(): void {
    this.toggled = !this.toggled;
  }
}
